<div class="card_offer" [ngClass]="cardClasses">
    <div class="row h_full direction_y">
        <div class="col_content card_top">
            <div [ngClass]="{'visuel' : isView('visual'), 'map_wrapper' : isView('map')}">
                @if(layoutView === 'list' && isView('map') && markers.length) {

                    <div class="map" leaflet [leafletOptions]="mapOptions" (leafletMapReady)="handleMapInitialization()" [leafletMarkerCluster]="markers"></div>
                }
                @if(isView('visual')) {

                    @if(offerTranslation.pictures.length) {
                        <img [src]="visualUrl" (error)="setDefaultVisualUrl()" [alt]="offerTranslation.name"/>
                    } @else {
                        <img [src]="offerCardService.defaultVisualUrl" [alt]="offerTranslation.name">
                    }
                }
                <div class="infos">
                    <div class="extras">
                        @if(layoutView === 'list') {

                            <!-- Passage en vue carte -->

                            @if(isView('visual') && item.hasMainOfferLocations) {
                                <span class="map-switch ty-map" (click)="setView('map')"></span>
                            }

                            <!-- Passage en vue liste -->

                            @if(isView('map') && offerTranslation.pictures.length) {
                                <span class="map-switch ty-eye" (click)="setView('visual')"></span>
                            }
                        }

                        @if(layoutView === 'map') {
                            <span class="map-switch map-close ty-close" (click)="closeItem.emit()"></span>
                        }

                        @if(displayOfferPublishedStatus) {
                            @if(item.published === 'published') {
                                <span class="status green" matTooltip="{{'offer.list.item.status.published.value' | translate}}" matTooltipPosition="above">P</span>
                            } @else if (item.published === 'restricted') {
                                <span class="status red" matTooltip="{{'offer.list.item.status.restricted.value' | translate}}" matTooltipPosition="above">R</span>
                            } @else if (item.published === 'draft') {
                                <span class="status blue" matTooltip="{{'offer.list.item.status.draft.value' | translate}}" matTooltipPosition="above">B</span>
                            }
                        }

                        @if(isOnAlert()) {
                            <span class="status vigilance" matTooltip="{{'offer.list.item.isOnAlert.value' | translate}}"></span>
                        }

                        @if(offerCardService.hashtagsDisplayed && item.hashtags.length) {

                            <span appCoreMaterialTooltipHtml class="hashtags" [content]="parsedHashtags">
                                <img ngSrc="assets/images/hashtag.png" alt="hashtags" height="142" width="140">
                            </span>
                        }

                    </div>

                    @if(isView('visual')) {

                        <div class="upper_left">
                            @if(item.isNew) {
                                <span class="new"><span>{{'offer.list.item.new.value' | translate}}</span></span>
                            }
                            @if(hasTranslationOnProcess) {
                                <span class="translation-process"><span>{{ 'offer.hasTranslationRequestToProcess.title.value' | translate }}</span></span>
                            }
                        </div>
                    }

                    <div class="tags">
                        @if(displayOfferOnlineSale) {
                            <span class="tag online-sale">
                                @if(displayOnlineSaleStatus('disable')) {
                                    <img src="assets/images/online-sale-grey.svg" alt="{{ 'offer.onlineSale.value' | translate }}" [matTooltip]="onlineSaleContent('disable')" />
                                } @else if (displayOnlineSaleStatus('warning')) {
                                    <img src="assets/images/online-sale-red.svg" alt="{{ 'offer.onlineSale.value' | translate }}" [matTooltip]="onlineSaleContent('warning')" />
                                } @else if (displayOnlineSaleStatus('available')) {
                                    <img src="assets/images/online-sale-green.svg" alt="{{ 'offer.onlineSale.value' | translate }}" [matTooltip]="onlineSaleContent('available')" />
                                }
                            </span>
                        }
                        @if(displayOfferGiftVoucher) {
                            <span class="tag gift-voucher">
                                @if(displayGiftVoucherStatus('available')) {
                                    <img src="assets/images/giftbox-green.svg" alt="{{ 'offer.giftVoucher.value' | translate }}" [matTooltip]="giftVoucherContent('available')" matTooltipPosition="above"/>
                                } @else if (displayGiftVoucherStatus('disable')) {
                                    <img src="assets/images/giftbox-grey.svg" [matTooltip]="giftVoucherContent('disable')" matTooltipPosition="above" alt="{{ 'offer.giftVoucher.value' | translate }}"/>
                                }
                            </span>
                        }
                        @if(displayPermanentOptions) {
                            <span class="tag online-sale">
                                <img src="assets/images/permanent-option.png" alt="{{ 'offer.permanentOptions.value' | translate }}" [matTooltip]="permanentOptionsContent"/>
                            </span>
                        }
                        @if(!displayPermanentOptions && hasOneOfThisMode(['personnal-offers', 'offer-permanent-option-personnal-offers', 'catalog', 'channel', 'offer-permanent-option-catalog', 'hashtag-catalog', 'article-catalog'])) {
                            <span class="tag online-sale">
                                <img src="assets/images/permanent-option-unavailable.png" alt="{{ 'offer.permanentOptions.unavailable.value' | translate }}" [matTooltip]="'offer.permanentOptions.unavailable.value' | translate"/>
                            </span>
                        }
                        @if(hasOfferPromotion && timerPromotion) {
                            <span class="tag promo">
                                <span><img src="assets/images/icons/icon_promo.svg"/>&nbsp;{{timerPromotion}}</span>
                            </span>
                        }
                        @if(isHighlighted) {
                            <span class="tag highlighted">
                                <span>{{'offer.list.item.highlighted.value' | translate}}</span>
                            </span>
                        }
                        @if(offerSearchService.displayReferencedOffer && isReferenced) {
                            <span class="tag referenced">
                                <span>{{ 'offer.referenced.value' | translate }}</span>
                            </span>
                        }
                    </div>
                </div>
            </div>
        </div>
        <div class="col card_bottom">
            <div class="infos_offer">
                <div class="row h_full direction_y">
                    <div class="col infos_wrapper">
                        <div class="infos" [ngClass]="{'closed' : cardClosed && layoutView == 'list'}">
                            <div class="row marges no_wrap">
                                <div class="col y_items_start title">
                                    <div class="row">
                                        <div class="col_12">
                                            <p>{{ offerTranslation.name }} @if(displayLocation) { ({{ displayLocation.city }})}</p>
                                        </div>
                                        <div class="col_content y_items_center">
                                            <div class="flags">
                                                @for(flag of locales; track flag) {
                                                    <span class="flag flag-{{flag}}"></span>
                                                }
                                                @for(flag of item.localesPendingTranslationRequest; track flag) {
                                                    <span class="flag flag-{{flag}} flag-pending" matTooltip="{{ 'offer.locale.hasTranslationRequestToProcess.description.value' | translate }}" matTooltipPosition="above"></span>
                                                }
                                            </div>
                                        </div>
                                        <div class="col y_items_center">
                                            <p class="duration">{{getDurationTranslation()?.label}}</p>
                                        </div>
                                    </div>
                                </div>
                                @if(layoutView == 'list') {
                                    <div class="col_content y_items_start">
                                        <span class="show_more ty-chevron" (click)="cardClosed ? cardClosed = false : cardClosed = true"></span>
                                    </div>
                                }
                            </div>

                            @if(item.startFromPriceHT || item.startFromPriceTTC) {
                                <div class="price">
                                    <span>{{ ((publicPrice && offerCatalog) ? ((item.isDisplayPriceHT ? offerCatalog.startFromPriceHT : offerCatalog.startFromPriceTTC) / 100) : ((item.isDisplayPriceHT ? item.startFromPriceHT : item.startFromPriceTTC) / 100)) | parsePrice }} {{ item.currency.symbol }} {{ (item.isDisplayPriceHT ? 'offer.price.type.ht.value' : 'offer.price.type.ttc.value') | translate }}</span>
                                    <div class="price_info">
                                        <span class="from">{{'offer.list.item.from.value' | translate}}</span>
                                        <span>{{'offer.list.item.perPerson.value' | translate}}</span>
                                    </div>
                                    @if(item.startFromPriceBasedOnParticipantCount) {
                                        <div class="price_info y_items_end x_end">
                                            <span class="participants">{{ 'offer.list.item.startFromPriceBasedOnParticipantCount.value' | translate: {count: item.startFromPriceBasedOnParticipantCount} }}</span>
                                        </div>
                                    }
                                </div>
                            }

                            <div class="description">
                                <p [innerHTML]="offerTranslation.teaser|safeHtml"></p>
                            </div>

                            <div class="infos_sup">

                                <!-- Addresse  -->
                                @if(showAddress && displayLocation) {

                                    <div class="row">
                                        <div class="col_5">
                                            <p>{{'offer.list.item.address.value' | translate}}</p>
                                        </div>
                                        <div class="col_7">
                                            <p>{{ displayLocation.address }}</p>
                                        </div>
                                    </div>
                                }

                                @if(hasOneOfThisRoles(['ROLE_OFFER_DISTRIBUTOR', 'ROLE_PROVIDER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION'])) {

                                    <div class="row">
                                        <div class="col_5">
                                            <p>{{'offer.list.item.producer.value' | translate}}</p>
                                        </div>
                                        <div class="col_7">
                                            @if(isMine) {
                                                <p>{{item.society.name}}</p>
                                            } @else {
                                                @if(!item.society.isProfileAvailable) {
                                                    <span>{{ item.society.name }}</span>
                                                } @else if(isRestrictedOfferCreator) {
                                                    <a href="javascript:void(0)" [matTooltip]="'offerCreator.notInCatalog.forbidden.value'|translate" matTooltipPosition="above" class="offer-creator-link">
                                                        <span>{{ item.society.name }}</span>
                                                    </a>
                                                } @else {
                                                    <a [routerLink]="['/account/offer-creator/read', item.society.id]" [target]="'_blank'" [queryParams]="{ 'list-redirection-allowed': 0 }" class="offer-creator-link">
                                                        <span>{{ item.society.name }}</span>
                                                    </a>
                                                }
                                            }
                                        </div>
                                    </div>
                                }

                                <div class="row">
                                    <div class="col_5">
                                        <p>{{'offer.list.item.type.value' | translate}}</p>
                                    </div>
                                    <div class="col_7">
                                        <p>{{getCustomerTypologyTranslation()?.name}}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col_5">
                                        <p>{{'offer.list.item.interest.value' | translate}}</p>
                                    </div>
                                    <div class="col_7">
                                        <ul class="interests">
                                            @for(interest of item.interests; track interest) {
                                                <li>{{ translationService.getFallbackTranslation(interest.translations).label}}</li>
                                            }
                                        </ul>
                                    </div>
                                </div>

                                <!-- Date de mise à jour -->

                                @if(hasOneOfThisRoles(['ROLE_OFFER_DISTRIBUTOR', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION', 'ROLE_OFFER_CREATOR', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_PROVIDER']) || hasOneOfThisMode(['catalog', 'hashtag-catalog', 'article-catalog'])) {

                                    <div class="row">
                                        <div class="col_5">
                                            <p>{{'offer.list.item.updatedAt.value' | translate}}</p>
                                        </div>
                                        <div class="col_7">
                                            <p>{{ item.updatedAt | amDateFormat:'DD MMMM YYYY'}}</p>
                                        </div>
                                    </div>
                                }

                                <!-- Créateur & Distributeur -->

                                @if(mode !== 'reservoir' && hasAllOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR']) && item.markup) {

                                    <div class="row">
                                        <div class="col_5">
                                            <p>{{'offer.form.fields.markup.value' | translate}}</p>
                                        </div>
                                        <div class="col_7">
                                            <p>{{ parseMarkup(item.markup * 100) }}</p>
                                        </div>
                                    </div>
                                }

                                <!-- Créateur -->

                                @if(mode !== 'reservoir' && hasRole('ROLE_OFFER_CREATOR') && !hasRole('ROLE_OFFER_DISTRIBUTOR') && item.markup) {

                                    <div class="row">
                                        <div class="col_5">
                                            <p>{{'offer.form.fields.markup.value' | translate}}</p>
                                        </div>
                                        <div class="col_7">
                                            <p>{{ parseMarkup(item.markup * 100) }}</p>
                                        </div>
                                    </div>
                                }

                                <!-- Distributeur -->

                                @if(mode !== 'reservoir' && offerCatalog && !hasRole('ROLE_OFFER_CREATOR') && (hasRole('ROLE_OFFER_DISTRIBUTOR'))) {

                                    <div class="row">
                                        <div class="col_5">
                                            <p>{{'offer.form.fields.markup.value' | translate}}</p>
                                        </div>
                                        <div class="col_7">
                                            <p>{{ parseMarkup(offerCatalog.markup * 100) }}</p>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col_content">
                        <div class="links_offer">

                            <!-- Actions customisées -->

                            @for(customAction of offerCardService.customActions; track customAction) {

                                @if(customAction.enabledCallback(item)) {

                                    <div [ngClass]="customAction.containerClassesCallback(item)">
                                        <a [ngClass]="customAction.buttonClassesCallback(item)" [matTooltip]="customAction.buttonTooltipCallback(item)" matTooltipPosition="above" [matTooltipDisabled]="!customAction.buttonTooltipDisplayedCallback(item)" (click)="customAction.clickCallback(item)">
                                            <span>{{ customAction.labelCallback(item) }}</span>
                                        </a>
                                    </div>
                                }
                            }

                            <!-- Gestion du catalogue -->

                            @if((hasOneOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_PROVIDER', 'ROLE_OFFER_DISTRIBUTOR', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION']))) {

                                @if(hasOneOfThisMode(['personnal-offers', 'reservoir', 'catalog'])) {

                                    @if(isAcceptedOfferCatalog) {

                                        @if(offerSearchService.deleteOfferFromCatalogAllowed) {

                                            <!-- Supression du catalogue -->

                                            @if(userService.hasAccess(user, 'OFFER_CATALOG_DELETE_IS_MINE')) {
                                                <div class="">
                                                    <a (click)="openDeleteCatalogueDialog()">
                                                        <span>{{'offer.list.item.action.catalog.delete.value' | translate}}</span>
                                                    </a>
                                                </div>
                                            }

                                        } @else {

                                            <div class="">
                                                <p>
                                                    <span>{{'offer.inCatalog.value' | translate}}</span>
                                                </p>
                                            </div>
                                        }
                                    }
                                }

                                @if(isMode('personnal-offers') || isMode('reservoir')) {

                                    @if(offerSearchService.addOfferToCatalogAllowed && !offerSearchService.multipleAccessRequestSelectionActivated.getValue()) {

                                        @if(((hasRole('ROLE_OFFER_CREATOR') && item.society.id === user.society.id) || hasRole('ROLE_PROVIDER')) && !isInCatalog && userService.hasAccess(user, 'OFFER_CATALOG_LIST')) {

                                            <!-- Ajout au catalogue -->

                                            <div [ngClass]="{ 'disabled': !userService.hasAccess(user, 'OFFER_CATALOG_CREATE'), 'btn_degrade': userService.hasAccess(user, 'OFFER_CATALOG_CREATE') && isMode('reservoir') }">
                                                <a (click)="addOfferToCatalog(item)" matTooltip="{{ 'offer.list.item.action.access.request.disabled.value' | translate }}" matTooltipPosition="above" [matTooltipDisabled]="userService.hasAccess(user, 'OFFER_CATALOG_CREATE')">
                                                    <span>{{'offer.list.item.action.catalog.add.value' | translate}}</span>
                                                </a>
                                            </div>
                                        }
                                    }
                                }
                            }

                            <!-- Demande d'acces -->

                            @if(offerSearchService.accessRequestOfferAllowed) {

                                @if(isMode('reservoir') && hasOneOfThisRoles(['ROLE_OFFER_DISTRIBUTOR', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION']) && (isRefusedOfferCatalog || !isInCatalog)) {

                                    @if(isRefusedOfferCatalog) {

                                        <div class="">
                                            <a>
                                                <span>{{ 'offer.accessRequest.refused.value' | translate }}</span>
                                            </a>
                                        </div>
                                    }

                                    @if(!isInCatalog) {

                                        @if(offerSearchService.multipleAccessRequestSelectionActivated.getValue()) {

                                            @if(!offerSearchService.isSelectedOfferToAccessRequest(item)) {

                                                <div class="btn_degrade">
                                                    <a (click)="offerSearchService.selectOfferToAccessRequest(item)" class="selectable">
                                                        <span>{{'offer.list.item.action.access.request.value' | translate}}</span>
                                                    </a>
                                                </div>

                                            } @else {

                                                <div class="btn_degrade">
                                                    <a (click)="offerSearchService.unselectOfferToAccessRequest(item)" class="selectable selected">
                                                        <span>{{'offer.list.item.action.access.request.value' | translate}}</span>
                                                    </a>
                                                </div>
                                            }

                                        } @else {

                                            @if(!isMine) {

                                                <div [ngClass]="{ 'disabled': !userService.hasAccess(user, 'OFFER_CATALOG_CREATE'), 'btn_degrade': userService.hasAccess(user, 'OFFER_CATALOG_CREATE') }">
                                                    <a (click)="addOfferToCatalog(item)" matTooltip="{{ 'offer.list.item.action.access.request.disabled.value' | translate }}" matTooltipPosition="above" [matTooltipDisabled]="userService.hasAccess(user, 'OFFER_CATALOG_CREATE')">
                                                        <span>{{'offer.list.item.action.access.request.value' | translate}}</span>
                                                    </a>
                                                </div>
                                            }
                                        }
                                    }
                                }
                            }

                            <!-- Edition d'une offre -->

                            @if(offerSearchService.updateOfferAllowed && isMode('personnal-offers')) {

                                @if(hasRole('ROLE_OFFER_CREATOR') && userService.hasAccess(user, 'OFFER_EDIT_IS_MINE')) {

                                    <div class="">
                                        <a (click)="updateItem(item.id)" [ngStyle]="{ opacity: hasTranslationOnProcess ? 0.5 : 1, cursor: hasTranslationOnProcess ? 'not-allowed' : 'pointer' }" matTooltip="{{ 'offer.hasTranslationRequestToProcess.description.value' | translate }}" matTooltipPosition="above" [matTooltipDisabled]="!hasTranslationOnProcess">
                                            <span>{{'offer.list.item.action.update.value' | translate}}</span>
                                        </a>
                                    </div>
                                }

                                @if(hasRole('ROLE_OFFER_CREATOR') && userService.hasAccess(user, 'OFFER_CREATE_IS_MINE')) {

                                    <div class="">
                                        <a (click)="openDuplicationDialog()" [ngStyle]="{ opacity: hasTranslationOnProcess ? 0.5 : 1, cursor: hasTranslationOnProcess ? 'not-allowed' : 'pointer' }" matTooltip="{{ 'offer.hasTranslationRequestToProcess.description.value' | translate }}" matTooltipPosition="above" [matTooltipDisabled]="!hasTranslationOnProcess">
                                            <span>{{'offer.duplication.action.value' | translate}}</span>
                                        </a>
                                    </div>
                                }
                            }

                            <!-- Sélection -->

                            @if(offerSearchService.selectOfferAllowed) {

                                @if(offerSearchService.isSelectedOffer(item)) {

                                    <div>
                                        <a (click)="offerSearchService.unselectOffer(item)">
                                            <span>{{'offer.unselect.action.value' | translate}}</span>
                                        </a>
                                    </div>

                                } @else {

                                    <div>
                                        <a (click)="offerSearchService.selectOffer(item)">
                                            <span>{{'offer.select.action.value' | translate}}</span>
                                        </a>
                                    </div>
                                }
                            }

                            <!-- Visualisation d'une offre -->

                            @if(offerSearchService.viewOfferAllowed) {

                                @if(hasAllOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR'])) {

                                    @if(hasOneOfThisMode(['personnal-offers', 'channel', 'reservoir', 'catalog', 'tender-proposed-offers', 'hashtag-catalog', 'article-catalog'])) {
                                        <ng-container *ngTemplateOutlet="viewOfferContent"></ng-container>
                                    }

                                } @else {

                                    @if((hasOneOfThisRoles(['ROLE_OFFER_DISTRIBUTOR', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION']) && hasOneOfThisMode(['reservoir', 'catalog', 'tender-proposed-offers', 'hashtag-catalog', 'article-catalog'])) || hasOneOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_PROVIDER'])) {
                                        <ng-container *ngTemplateOutlet="viewOfferContent" ></ng-container>
                                    }
                                }

                                <ng-template #viewOfferContent>
                                    <div>
                                        <a (click)="goToOffer(item)" [ngStyle]="{ opacity: hasTranslationOnProcess ? 0.5 : 1, cursor: hasTranslationOnProcess ? 'not-allowed' : 'pointer' }" matTooltip="{{ 'offer.hasTranslationRequestToProcess.description.value' | translate }}" matTooltipPosition="above" [matTooltipDisabled]="!hasTranslationOnProcess">
                                            <span>{{'offer.list.item.action.see.value' | translate}}</span>
                                        </a>
                                    </div>
                                </ng-template>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
